<template>
<div>
    <div class=" h-12 bg-white z-10 fixed top-0 w-full border-gray-200 border">
        
      <div class="flex  h-full items-center justify-start">
          <div @click="toggleDrawer" class="flex md:hidden cursor-pointer border-r h-full items-center text-xl px-4  justify-center">
              <i class='bx bx-menu' ></i>
          </div>
          <div class=" flex px-4 items-center justify-center h-full md:border-r border-gray-200">
              <span class=" font-mono text-sm">Sheldon Zhang</span>
          </div>
          <div class=" hidden md:flex flex-1">
              <div class=" w-full pl-4  font-mono uppercase space-x-4">
              <router-link  class="inactive-link" to="/">Home</router-link>
              <router-link  class="inactive-link" to="/projects">Projects</router-link>
              <router-link class="inactive-link" to="/resume">Resume</router-link>
          </div>
          <div class=" mr-4">
              <a href="https://github.com/zzy98y"><i class='bx bxl-github text-xl'></i></a>
          </div>
          </div>
          
      </div>
  </div>
  <div v-if="showDrawer" class="fixed z-20 top-0 bg-white w-full flex md:hidden font-mono uppercase flex-col">
      <div class="flex  h-full items-center border-b px-4 py-3">
          <box-icon @click="toggleDrawer" class="cursor-pointer" name='x'></box-icon>
      </div>
      <div class="flex items-center border-b px-4 py-4">
          <router-link  @click.native="toggleDrawer" class="inactive-link w-full" to="/">Home</router-link>
          <i class='bx text-gray-400 bx-chevron-right'></i>
      </div>
      <div class="flex items-center border-b px-4 py-4">
          <router-link  @click.native="toggleDrawer" class="inactive-link w-full" to="/projects">Projects</router-link>
          <i class='bx text-gray-400 bx-chevron-right'></i>
      </div>
      <div class="flex items-center border-b px-4 py-4">
          <router-link  @click.native="toggleDrawer" class="inactive-link w-full" to="/resume">Resume</router-link>
          <i class='bx text-gray-400 bx-chevron-right'></i>
      </div>
  </div>
</div>
  
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            showDrawer:false
        }
    },
    methods: {
        toggleDrawer() {
            this.showDrawer = !this.showDrawer
        }
    }
}
</script>

<style scoped>
.inactive-link {
    color: #969696;
}
.inactive-link:hover {
    color: #5f5f5f;
}
.router-link-exact-active {
    color: black !important;
}
</style>